import React, {Component} from 'react';
import "./index.css";
import reply_util from "../../util/clipstore/user/reply";
import {Collapse} from 'reactstrap';
import {connect} from "react-redux";
import * as actions from "../../actions";
import HideShowReply from "../../components/HideShowReply";
import CommentListItem from "../../components/clipstore/user/comment/list-item";
import comment_util from "../../util/clipstore/user/comment";
import * as _ from "lodash";
import Loading from "react-loading-animation";

class Replies extends Component {

    constructor() {
        super();
        this.state = {
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            replyList: [],

            showReplies: false,
            commentText: '',
            deleteComment: {},
        }
    }

    componentDidMount() {
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
        //this will be called for every pagination we perform
        if (nextProps.get_reply && nextProps.get_reply.payload !== this.props.get_reply.payload) {

            if (nextProps.get_reply.payload &&
                nextProps.get_reply.payload.hasOwnProperty("success") &&
                nextProps.get_reply.payload.success.hasOwnProperty("data") &&
                nextProps.get_reply.payload.success.data.hasOwnProperty("data")) {

                let data = nextProps.get_reply.payload.success.data;
                let replyList = data.data;

                console.log("UNSAFE_componentWillReceiveProps >> replyList", data)

                if (replyList.length > 0) {
                    replyList = this.state.replyList.concat(replyList)
                } else {
                    replyList = this.state.replyList;
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) < parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.data.length,
                    totalItems: parseInt(data.total),
                    replyList,
                    reset: false
                }, () => {
                    // if (this.state.hasMore && this.state.currentPage < 3) {
                    //     this.loadNextPage();
                    // }
                })
            }
        }

        //response for update comment
        comment_util.apiUpdate(nextProps, "update_reply", () => {
            this.updateElementFromArray(nextProps.update_reply.payload.success.data);
        }, () => {
            this.props.resetUpdateReply();
        })

        //response for delete comment
        comment_util.apiUpdate(nextProps, "delete_reply", () => {
            this.removeElementFromArray(this.state.deleteComment);
        }, () => {
            this.props.resetDeleteReply();
        })
    }

    addElementFromArray = (commentObj) => {
        let replyList = this.state.replyList;
        //arr.splice(index, 0, item);
        replyList.splice(0, 0, commentObj);
        this.setState({
            replyList,
            totalItems: this.state.totalItems + 1
        })
    }

    /**
     * @function which mutates the state of replyList by removing content
     * @param commentObj
     */
    updateElementFromArray = (commentObj) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.replyList, (o) => {
            return o.comment_id === commentObj.comment_id;
        });

        //copy the element
        let replyList = this.state.replyList;

        //Update index element from index
        replyList[index] = commentObj;

        this.setState({
            replyList
        })
    };

    /**
     * @function which mutates the state of replyList by removing content
     * @param commentObj
     */
    removeElementFromArray = (commentObj) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.replyList, (o) => {
            return _.isMatch(o, commentObj)
        });

        //add the element
        let replyList = this.state.replyList;

        //Remove 1 element from index 3
        replyList.splice(index, 1);

        this.setState({
            replyList,
            totalItems: this.state.totalItems - 1
        })
    };


    loadNextPage = () => {

        if (this.state.hasMore) {
            let currentPage = this.state.currentPage;
            currentPage = currentPage + 1;

            this.setState({
                currentPage
            }, () => {
                reply_util.getReplyListAPI(this.props, this.props.comment_id, this.state.currentPage)
            })
        }
    }

    toggleShowReplies = () => {
        this.setState({
            showReplies: !this.state.showReplies,
            replyList: !this.state.showReplies ? [] : this.state.replyList
        }, () => {
            if (this.state.showReplies) {
                reply_util.getReplyListAPI(this.props, this.props.comment_id, this.state.currentPage)
            }
        })
    }

    setCommentText = (value) => {
        this.setState({
            commentText: value
        })
    }

    setDeleteComment = (comment) => {
        this.setState({
            deleteComment: comment
        })
    }

    render() {

        if (this.props.reply_count > 0) {
            return (
                <div className="reply-container">
                    <HideShowReply toggle={this.toggleShowReplies} replyCount={this.props.reply_count}
                                   open={this.state.showReplies}/>
                    <Collapse isOpen={this.state.showReplies} style={{marginTop: 10}}>
                        {
                            this.state.replyList.length === 0 && this.props.get_reply.isFetching
                                ?
                                <Loading/>
                                :
                                this.state.replyList.map((reply, index) => {
                                    return (
                                        <CommentListItem
                                            {...this.props}
                                            key={`${reply.comment_id}`}
                                            comment={reply}
                                            currentUser={this.props.currentUser}
                                            setDeleteComment={this.setDeleteComment}
                                            type="reply"
                                        />
                                    )
                                })
                        }
                    </Collapse>
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

Replies.propTypes = {};

function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        get_reply: state.get_reply,
        create_reply: state.create_reply,
        update_reply: state.update_reply,
        delete_reply: state.delete_reply,
    };
}

export default connect(mapStateToProps, actions)(Replies);
